var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-container"},[_c('div',{staticClass:"lds-agreement",domProps:{"innerHTML":_vm._s(_vm.htmlTextAgreement)}})])}
var staticRenderFns = []

export { render, staticRenderFns }